module.exports = __webpack_public_path__ + "static/icons/icon-skiing-8e420d1d5684eb2e9b51c09e1289153b.svg";